import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { ProxyTypeEnum } from '../interfaces/proxy-type-enum';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';
import { CombinedMenuItemTypeEnum } from '../interfaces/combined-menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Quick Quiz',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'combined-quick-quiz',
  },
  {
    Text: 'Mistakes Quiz',
    ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
    DestinationPage: 'combined-mistakes-quiz',
  },
  {
    Text: 'Summary Test',
    ImagePath: '/assets/images/landing/revision-summary-test.png',
    DestinationPage: 'combined-revision-summary-quiz',
  },
  {
    Text: 'Video Explanations',
    ImagePath: '/assets/images/landing/video-explanations.png',
    DestinationPage: 'combined-content-videos',
  },
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.CombinedQuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Chem_QuickQuiz_v5',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Phys_QuickQuiz_v4',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Bio_QuickQuiz_v7',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Test yourself with quizzes covering every topic. On your marks, get set... quiz!</p>' +
      '\n' +
      '<span>Questions marked:</span><br/>' +
      '<span>Biology: <strong>[[variable1]]</strong></span><br/>' +
      '<span>Chemistry: <strong>[[variable2]]</strong></span><br/>' +
      '<span>Physics: <strong>[[variable3]]</strong></span>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedMistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Mistakes Quiz',
    ButtonURL: 'combined-revision-summary-quiz',

    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Chem_YourMistakes_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Phys_YourMistakes_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Bio_YourMistakes_v5',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here &mdash; have another go and conquer them once and for all!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers\n',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedRevisionSummaryQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: '',

    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Chem_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Phys_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl: '_revisionhub_opc/SCAFS43/SCAFS43_Bio_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>' +
      '\n' +
      '<span>Questions answered:</span><br/>' +
      '<span>Biology: <strong>[[variable1]]</strong></span><br/>' +
      '<span>Chemistry: <strong>[[variable2]]</strong></span><br/>' +
      '<span>Physics: <strong>[[variable3]]</strong></span>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedVideoExplanations,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch explanations',
    MixedOnlineTests: [],
    ButtonURL: '',
    HasData: false,
    HeadingText: 'Video Explanations',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Our Science experts break down key concepts for you — even the tricky bits!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Get to grips with key concepts',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        Title: 'Video Explanations',
        Intro:
          'These handy videos explain some of the key concepts in your book. So grab your popcorn (or a pencil) and dig in!',
        LeftSections: [
          {
            Header: 'Topic B1 — Cell Biology',
            Subcategories: [
              {
                Name: 'The Cell Cycle and Mitosis',
                ShortName: 'The-Cell-Cycle-and-Mitosis',
                Link: 'https://www.youtube.com/embed/5zSL1xQ9tOc?rel=0&modestbranding=1',
              },
              {
                Name: 'Diffusion',
                ShortName: 'Diffusion',
                Link: 'https://www.youtube.com/embed/TahOKtPHrl4?rel=0&modestbranding=1',
              },
              {
                Name: 'Osmosis',
                ShortName: 'Osmosis',
                Link: 'https://www.youtube.com/embed/CizgcfyOFoY?rel=0&modestbranding=1',
              },
              {
                Name: 'Active Transport in the Gut',
                ShortName: 'Active-Transport-in-the-Gut',
                Link: 'https://www.youtube.com/embed/qluo1t2JKAc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B2a — Organisation, Enzymes and Circulation',
            Subcategories: [
              {
                Name: 'Enzymes',
                ShortName: 'Enzymes',
                Link: 'https://www.youtube.com/embed/9cMF8qJdaFI?rel=0&modestbranding=1',
              },
              {
                Name: 'Gas Exchange',
                ShortName: 'Gas-Exchange',
                Link: 'https://www.youtube.com/embed/-QAeAfQ8hjo?rel=0&modestbranding=1',
              },
              {
                Name: 'The Double Circulatory System',
                ShortName: 'The-Double-Circulatory-System',
                Link: 'https://www.youtube.com/embed/GcDgKpxvCX8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B2b — Disease and Plant Organisation',
            Subcategories: [
              {
                Name: 'Transpiration',
                ShortName: 'Transpiration',
                Link: 'https://www.youtube.com/embed/2rCNRcUp8rQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B3 — Infection and Response',
            Subcategories: [
              {
                Name: 'Vaccinations',
                ShortName: 'Vaccinations',
                Link: 'https://www.youtube.com/embed/KawDHstCjWw?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B5 — Homeostasis and Response',
            Subcategories: [
              {
                Name: 'Reflexes',
                ShortName: 'Reflexes',
                Link: 'https://www.youtube.com/embed/aBHUttz6fYY?rel=0&modestbranding=1',
              },
              {
                Name: 'Controlling Blood Glucose',
                ShortName: 'Controlling-Blood-Glucose',
                Link: 'https://www.youtube.com/embed/KmbsIM7OE0o?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B6a — DNA and Reproduction',
            Subcategories: [
              {
                Name: 'Meiosis',
                ShortName: 'Meiosis',
                Link: 'https://www.youtube.com/embed/-XqX5djlSdA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B7 — Ecology',
            Subcategories: [
              {
                Name: 'The Water Cycle',
                ShortName: 'The-Water-Cycle',
                Link: 'https://www.youtube.com/embed/bjD0aUj20SM?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        Title: 'Video Explanations',
        Intro:
          'These handy videos explain some of the key concepts in your book. So grab your popcorn (or a pencil) and dig in!',
        LeftSections: [
          {
            Header: 'Topic C1a — Atoms, Elements, Compounds and Mixture',
            Subcategories: [
              {
                Name: 'Structure of the Atom',
                ShortName: 'Structure-of-the-Atom',
                Link: 'https://www.youtube.com/embed/qlICQ6YZbWU?rel=0&modestbranding=1',
              },
              {
                Name: 'Paper Chromatography',
                ShortName: 'Paper-Chromatography',
                Link: 'https://www.youtube.com/embed/wrGI1vHoLtU?rel=0&modestbranding=1',
              },
              {
                Name: 'Separation Techniques',
                ShortName: 'Separation-Techniques',
                Link: 'https://www.youtube.com/embed/IeoWXK3we-E?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C1b — The Periodic Table',
            Subcategories: [
              {
                Name: 'The Gold Foil Experiment',
                ShortName: 'The-Gold-Foil-Experiment',
                Link: 'https://www.youtube.com/embed/SPP8PMbI5Ys?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C2 — Bonding, Structure and Properties of Matter',
            Subcategories: [
              {
                Name: 'States of Matter',
                ShortName: 'States-of-Matter',
                Link: 'https://www.youtube.com/embed/ZsAhe9c5Dqs?rel=0&modestbranding=1',
              },
              {
                Name: 'Changes of State',
                ShortName: 'Changes-of-State',
                Link: 'https://www.youtube.com/embed/NQaIu23k91c?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C3 — Quantitative Chemistry',
            Subcategories: [
              {
                Name: 'Conservation of Mass',
                ShortName: 'Conservation-of-Mass',
                Link: 'https://www.youtube.com/embed/1-DNcOAA8ro?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C4 — Chemical Changes',
            Subcategories: [
              {
                Name: 'Electrolysis of Aqueous Solutions',
                ShortName: 'Electrolysis-of-Aqueous-Solutions',
                Link: 'https://www.youtube.com/embed/BJCm7ZkzTsM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C6 — The Rate and Extent of Chemical Change',
            Subcategories: [
              {
                Name: 'Factors Affecting Rate of Reaction',
                ShortName: 'Factors-Affecting-Rate-of-Reaction',
                Link: 'https://www.youtube.com/embed/zd6J_TGK7og?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C7 — Organic Chemistry',
            Subcategories: [
              {
                Name: 'Fractional Distillation',
                ShortName: 'Fractional-Distillation',
                Link: 'https://www.youtube.com/embed/Es1w80DhgWc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C8 — Chemical Analysis',
            Subcategories: [
              {
                Name: 'Tests for Gases',
                ShortName: 'Tests-for-Gases',
                Link: 'https://www.youtube.com/embed/ylwKHIoDp9c?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C9 — Chemistry of the Atmosphere',
            Subcategories: [
              {
                Name: 'Evolution of the Atmosphere',
                ShortName: 'Evolution-of-the-Atmosphere',
                Link: 'https://www.youtube.com/embed/MXQThYl7Eb8?rel=0&modestbranding=1',
              },
              {
                Name: 'Acid Rain',
                ShortName: 'Acid-Rain',
                Link: 'https://www.youtube.com/embed/OcMRovgs9WI?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C10 — Using Resources',
            Subcategories: [
              {
                Name: 'Sewage Treatment',
                ShortName: 'Sewage-Treatment',
                Link: 'https://www.youtube.com/embed/HZNkwK4pALw?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        Title: 'Video Explanations',
        Intro:
          'These handy videos explain some of the key concepts in your book. So grab your popcorn (or a pencil) and dig in!',
        LeftSections: [
          {
            Header: 'Topic P1 — Energy',
            Subcategories: [
              {
                Name: 'Specific Heat Capacity',
                ShortName: 'Specific-Heat-Capacity',
                Link: 'https://www.youtube.com/embed/hJ8aplV4Aog?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P2 — Electricity',
            Subcategories: [
              {
                Name: 'Sensing Circuits',
                ShortName: 'Sensing-Circuits',
                Link: 'https://www.youtube.com/embed/YgUJa8kw3C8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P3 — Particle Model of Matter',
            Subcategories: [
              {
                Name: 'States of Matter',
                ShortName: 'States-of-Matter',
                Link: 'https://www.youtube.com/embed/j2JtspLUzdc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P4 — Atomic Structure',
            Subcategories: [
              {
                Name: 'Half-life',
                ShortName: 'Half-life',
                Link: 'https://www.youtube.com/embed/LDFHzGwjK40?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P5a — Force Basics and Springs',
            Subcategories: [
              {
                Name: 'Investigating Springs',
                ShortName: 'Investigating-Springs',
                Link: 'https://www.youtube.com/embed/FIVaAytimaM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P5b — Forces and Motion',
            Subcategories: [
              {
                Name: 'Terminal Velocity',
                ShortName: 'Terminal-Velocity',
                Link: 'https://www.youtube.com/embed/LLOI0dG4zAg?rel=0&modestbranding=1',
              },
              {
                Name: "Newton\'s Third Law",
                ShortName: "Newton\'s Third Law",
                Link: 'https://www.youtube.com/embed/T_Bc3pHu8A4?rel=0&modestbranding=1',
              },
              {
                Name: 'Stopping Distances',
                ShortName: 'Stopping-Distances',
                Link: 'https://www.youtube.com/embed/pfKq48Wnwj8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P6 — Waves',
            Subcategories: [
              {
                Name: 'Transverse and Longitudinal Waves',
                ShortName: 'Transverse-and-Longitudinal-Waves',
                Link: 'https://www.youtube.com/embed/bYIAZL-GcmE?rel=0&modestbranding=1',
              },
              {
                Name: 'Speed of Sound',
                ShortName: 'Speed-of-Sound',
                Link: 'https://www.youtube.com/embed/G8wx_4G18iM?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedVideoSolutions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],
    ButtonURL: '',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic B1 — Cell Biology',
            Subcategories: [
              {
                Name: 'Magnification',
                ShortName: 'Magnification',
                Link: 'https://www.youtube.com/embed/MEREsZWMRZE?rel=0&modestbranding=1',
              },
              {
                Name: 'Mitosis',
                ShortName: 'Mitosis',
                Link: 'https://www.youtube.com/embed/B9GedI8mWbQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Diffusion',
                ShortName: 'Diffusion',
                Link: 'https://www.youtube.com/embed/hEcfOMmvYdk?rel=0&modestbranding=1',
              },
              {
                Name: 'Surface Area to Volume Ratios',
                ShortName: 'Surface-Area-to-Volume-Ratios',
                Link: 'https://www.youtube.com/embed/StPUz-sn4Q8?rel=0&modestbranding=1',
              },
              {
                Name: 'Exchange Surfaces',
                ShortName: 'Exchange-Surfaces',
                Link: 'https://www.youtube.com/embed/TQIOFgRNL1A?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B2a — Organisation, Enzymes and Circulation\n',
            Subcategories: [
              {
                Name: 'The Rate of Enzyme Activity',
                ShortName: 'The-Rate-of-Enzyme-Activity',
                Link: 'https://www.youtube.com/embed/9XPmXqPaAyc?rel=0&modestbranding=1',
              },
              {
                Name: 'Breathing Rate',
                ShortName: 'Breathing-Rate',
                Link: 'https://www.youtube.com/embed/QFf9hLBjBCw?rel=0&modestbranding=1',
              },
              {
                Name: 'The Rate of Blood Flow',
                ShortName: 'The-Rate-of-Blood-Flow',
                Link: 'https://www.youtube.com/embed/wW-aZvUHCmY?rel=0&modestbranding=1',
              },
              {
                Name: 'Blood Cells',
                ShortName: 'Blood-Cells',
                Link: 'https://www.youtube.com/embed/1Ec_ytkhTiU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B2b — Disease and Plant Organisation',
            Subcategories: [
              {
                Name: 'Transpiration',
                ShortName: 'Transpiration',
                Link: 'https://www.youtube.com/embed/QrGlRhXJxMc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B3 — Infection and Response\n',
            Subcategories: [
              {
                Name: 'Vaccination',
                ShortName: 'Vaccination',
                Link: 'https://www.youtube.com/embed/-ydxd0-zD0A?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B4 — Bioenergetics',
            Subcategories: [
              {
                Name: 'Limiting Factors of Photosynthesis',
                ShortName: 'Limiting-Factors-of-Photosynthesis',
                Link: 'https://www.youtube.com/embed/fprWsvT8GJ0?rel=0&modestbranding=1',
              },
              {
                Name: 'Exercise',
                ShortName: 'Exercise',
                Link: 'https://www.youtube.com/embed/vHiDj8ZkYiU?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic B5 — Homeostasis and Response',
            Subcategories: [
              {
                Name: 'Reflex Reactions',
                ShortName: 'Reflex-Reactions',
                Link: 'https://www.youtube.com/embed/uTGmrc0w6C8?rel=0&modestbranding=1',
              },
              {
                Name: 'Investigating Reaction Time',
                ShortName: 'Investigating-Reaction-Time',
                Link: 'https://www.youtube.com/embed/rze8YclL-KQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Controlling Blood Glucose',
                ShortName: 'Controlling-Blood-Glucose',
                Link: 'https://www.youtube.com/embed/zg26u8PPDTs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B6a — DNA and Reproduction',
            Subcategories: [
              {
                Name: 'Meiosis',
                ShortName: 'Meiosis',
                Link: 'https://www.youtube.com/embed/Fmz0jp0ipRo?rel=0&modestbranding=1',
              },
              {
                Name: 'Genetic Diagrams',
                ShortName: 'Genetic-Diagrams',
                Link: 'https://www.youtube.com/embed/qLXmeodHeEo?rel=0&modestbranding=1',
              },
              {
                Name: 'Family Trees',
                ShortName: 'Family-Trees',
                Link: 'https://www.youtube.com/embed/-PvtACg5J9M?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B6b — Variation, Evolution and Classification',
            Subcategories: [
              {
                Name: 'Evolution',
                ShortName: 'Evolution',
                Link: 'https://www.youtube.com/embed/cAyK4Aj3_Lc?rel=0&modestbranding=1',
              },
              {
                Name: 'Selective Breeding',
                ShortName: 'Selective-Breeding',
                Link: 'https://www.youtube.com/embed/_AzxzW3IkFU?rel=0&modestbranding=1',
              },
              {
                Name: 'Evolutionary Trees',
                ShortName: 'Evolutionary-Trees',
                Link: 'https://www.youtube.com/embed/hcC1s_4MPXg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B7 — Ecology',
            Subcategories: [
              {
                Name: 'Interdependence',
                ShortName: 'Interdependence',
                Link: 'https://www.youtube.com/embed/ThF6whT_m6s?rel=0&modestbranding=1',
              },
              {
                Name: 'Adaptations',
                ShortName: 'Adaptations',
                Link: 'https://www.youtube.com/embed/zb9Vz8Zwfjw?rel=0&modestbranding=1',
              },
              {
                Name: 'Food Chains',
                ShortName: 'Food-Chains',
                Link: 'https://www.youtube.com/embed/zR-fzoN-xts?rel=0&modestbranding=1',
              },
              {
                Name: 'Using Quadrats',
                ShortName: 'Using-Quadrats',
                Link: 'https://www.youtube.com/embed/kvO-YffI4l0?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic C1a — Atoms, Elements, Compounds & Mixtures',
            Subcategories: [
              {
                Name: 'Atoms',
                ShortName: 'Atoms',
                Link: 'https://www.youtube.com/embed/m1vMiZvzGaE?rel=0&modestbranding=1',
              },
              {
                Name: 'Calculating Relative Atomic Mass',
                ShortName: 'Calculating-Relative-Atomic-Mass',
                Link: 'https://www.youtube.com/embed/WakAOxVH4sY?rel=0&modestbranding=1',
              },
              {
                Name: 'Compound Formulas',
                ShortName: 'Compound-Formulas',
                Link: 'https://www.youtube.com/embed/ILzKxoQXf4Q?rel=0&modestbranding=1',
              },
              {
                Name: 'Chemical Equations',
                ShortName: 'Chemical-Equations',
                Link: 'https://www.youtube.com/embed/9ihnB-r4_qo?rel=0&modestbranding=1',
              },
              {
                Name: 'Distillation',
                ShortName: 'Distillation',
                Link: 'https://www.youtube.com/embed/340kfE8xEfs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C1b — The Periodic Table',
            Subcategories: [
              {
                Name: 'Electronic Structure',
                ShortName: 'Electronic-Structure',
                Link: 'https://www.youtube.com/embed/M5zih_oL88E?rel=0&modestbranding=1',
              },
              {
                Name: 'Group 1 Elements',
                ShortName: 'Group-1-Elements',
                Link: 'https://www.youtube.com/embed/-8C9QmrxBx4?rel=0&modestbranding=1',
              },
              {
                Name: 'Group 7 Elements',
                ShortName: 'Group-7-Elements',
                Link: 'https://www.youtube.com/embed/DKl05_fJ8Rg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C2 — Bonding, Structure and Properties of Matter',
            Subcategories: [
              {
                Name: 'Ion Formation',
                ShortName: 'Ion-Formation',
                Link: 'https://www.youtube.com/embed/_tRLGRECAsY?rel=0&modestbranding=1',
              },
              {
                Name: 'Ionic Bonding',
                ShortName: 'Ionic-Bonding',
                Link: 'https://www.youtube.com/embed/TvZVyMC4soo?rel=0&modestbranding=1',
              },
              {
                Name: 'Ionic Compounds',
                ShortName: 'Ionic-Compounds',
                Link: 'https://www.youtube.com/embed/TpGQX5HCoKE?rel=0&modestbranding=1',
              },
              {
                Name: 'Covalent Bonding',
                ShortName: 'Covalent-Bonding',
                Link: 'https://www.youtube.com/embed/ZVMxvZML5qg?rel=0&modestbranding=1',
              },
              {
                Name: 'Polymers',
                ShortName: 'Polymers',
                Link: 'https://www.youtube.com/embed/3OLb-Y7U_7w?rel=0&modestbranding=1',
              },
              {
                Name: 'Structures of Carbon',
                ShortName: 'Structures-of-Carbon',
                Link: 'https://www.youtube.com/embed/0yx_IunkQAI?rel=0&modestbranding=1',
              },
              {
                Name: 'Changing State',
                ShortName: 'Changing-State',
                Link: 'https://www.youtube.com/embed/AtlF9E_4EkQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C3 — Quantitative  Chemistry',
            Subcategories: [
              {
                Name: 'Calculating Percentage Composition',
                ShortName: 'Calculating-Percentage-Composition',
                Link: 'https://www.youtube.com/embed/AmUsRuohYpo?rel=0&modestbranding=1',
              },
              {
                Name: 'Conservation of Mass',
                ShortName: 'Conservation-of-Mass',
                Link: 'https://www.youtube.com/embed/HQg-hFiK0AA?rel=0&modestbranding=1',
              },
              {
                Name: 'Mass Change in Reactions',
                ShortName: 'Mass-Change-in-Reactions',
                Link: 'https://www.youtube.com/embed/Tby8mveFe8E?rel=0&modestbranding=1',
              },
              {
                Name: 'Concentration Calculations',
                ShortName: 'Concentration-Calculations',
                Link: 'https://www.youtube.com/embed/SiqXK7P-zVU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C4 — Chemical Changes',
            Subcategories: [
              {
                Name: 'Reactions of Acids',
                ShortName: 'Reactions-of-Acids',
                Link: 'https://www.youtube.com/embed/eGk6bylEi8M?rel=0&modestbranding=1',
              },
              {
                Name: 'Separating Metals From Metal Oxides',
                ShortName: 'Separating-Metals-From-Metal-Oxides',
                Link: 'https://www.youtube.com/embed/t_ZjE0dyQqA?rel=0&modestbranding=1',
              },
              {
                Name: 'Reactions of Metals',
                ShortName: 'Reactions-of-Metals',
                Link: 'https://www.youtube.com/embed/iJSIYFa-Alo?rel=0&modestbranding=1',
              },
              {
                Name: 'Electrolysis of Molten Ionic Compounds',
                ShortName: 'Electrolysis-of-Molten-Ionic-Compounds',
                Link: 'https://www.youtube.com/embed/APpdE4PgEoU?rel=0&modestbranding=1',
              },
              {
                Name: 'Electrolysis of Aqueous Solutions',
                ShortName: 'Electrolysis-of-Aqueous-Solutions',
                Link: 'https://www.youtube.com/embed/LhOO3sSrxvs?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic C5 — Energy Changes',
            Subcategories: [
              {
                Name: 'Drawing Reaction Profiles',
                ShortName: 'Drawing-Reaction-Profiles',
                Link: 'https://www.youtube.com/embed/UW2AgzybgDE?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C6 — The Rate and Extent of Chemical Change',
            Subcategories: [
              {
                Name: 'Graphs of Reaction Rate Experiments',
                ShortName: 'Graphs-of-Reaction-Rate-Experiments',
                Link: 'https://www.youtube.com/embed/2OcR1OR0Zb8?rel=0&modestbranding=1',
              },
              {
                Name: 'Calculating Rates of Reaction',
                ShortName: 'Calculating-Rates-of-Reaction',
                Link: 'https://www.youtube.com/embed/kyOOnhxpHUc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C7 — Organic Chemistry',
            Subcategories: [
              {
                Name: 'Combustion of Hydrocarbons',
                ShortName: 'Combustion-of-Hydrocarbons',
                Link: 'https://www.youtube.com/embed/yii1EOm5uyU?rel=0&modestbranding=1',
              },
              {
                Name: 'Separating Hydrocarbon Fractions',
                ShortName: 'Separating-Hydrocarbon-Fractions',
                Link: 'https://www.youtube.com/embed/5ifdkkq3SDM?rel=0&modestbranding=1',
              },
              {
                Name: 'Cracking Crude Oil',
                ShortName: 'Cracking-Crude-Oil',
                Link: 'https://www.youtube.com/embed/YiHC8GwPyls?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C8 — Chemical Analysis',
            Subcategories: [
              {
                Name: 'Paper Chromatography',
                ShortName: 'Paper-Chromatography',
                Link: 'https://www.youtube.com/embed/5NZ5zHMkYLI?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C9 — Chemistry of the Atmosphere',
            Subcategories: [
              {
                Name: 'The Greenhouse Effect',
                ShortName: 'The-Greenhouse-Effect',
                Link: 'https://www.youtube.com/embed/TiKgDB24lws?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C10 — Using Resources',
            Subcategories: [
              {
                Name: 'Making Potable Water',
                ShortName: 'Making-Potable-Water',
                Link: 'https://www.youtube.com/embed/t0wcIA60Pmg?rel=0&modestbranding=1',
              },
              {
                Name: 'Treating Waste Water',
                ShortName: 'Treating-Waste-Water',
                Link: 'https://www.youtube.com/embed/da00MjZU7hU?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic P1 — Energy',
            Subcategories: [
              {
                Name: 'Energy Stores and Transfers',
                ShortName: 'Energy-Stores-and-Transfers',
                Link: 'https://www.youtube.com/embed/fGtie6c3dEA?rel=0&modestbranding=1',
              },
              {
                Name: 'Kinetic and Potential Energy Stores',
                ShortName: 'Kinetic-and-Potential-Energy-Stores',
                Link: 'https://www.youtube.com/embed/QzKGF5Recv4?rel=0&modestbranding=1',
              },
              {
                Name: 'Specific Heat Capacity',
                ShortName: 'Specific-Heat-Capacity',
                Link: 'https://www.youtube.com/embed/-7Ld5j5l84k?rel=0&modestbranding=1',
              },
              {
                Name: 'Investigating Specific Heat Capacity',
                ShortName: 'Investigating-Specific-Heat-Capacity',
                Link: 'https://www.youtube.com/embed/la32u7SQURg?rel=0&modestbranding=1',
              },
              {
                Name: 'Power Output',
                ShortName: 'Power-Output',
                Link: 'https://www.youtube.com/embed/jHR0vsRlNmM?rel=0&modestbranding=1',
              },
              {
                Name: 'Efficiency',
                ShortName: 'Efficiency',
                Link: 'https://www.youtube.com/embed/BORdE6I2aTM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P2 — Electricity',
            Subcategories: [
              {
                Name: 'Current and Charge',
                ShortName: 'Current-and-Charge',
                Link: 'https://www.youtube.com/embed/odLKOSpmkXE?rel=0&modestbranding=1',
              },
              {
                Name: 'Resistance',
                ShortName: 'Resistance',
                Link: 'https://www.youtube.com/embed/7e6rBWc98a0?rel=0&modestbranding=1',
              },
              {
                Name: 'I-V Characteristics',
                ShortName: 'I-V-Characteristics',
                Link: 'https://www.youtube.com/embed/hwO_Tdi1dV8?rel=0&modestbranding=1',
              },
              {
                Name: 'LDRs',
                ShortName: 'LDRs',
                Link: 'https://www.youtube.com/embed/jGxZ--ZPa24?rel=0&modestbranding=1',
              },
              {
                Name: 'Series Circuits',
                ShortName: 'Series-Circuits',
                Link: 'https://www.youtube.com/embed/6fF3TpR_fVU?rel=0&modestbranding=1',
              },
              {
                Name: 'Parallel Circuits',
                ShortName: 'Parallel-Circuits',
                Link: 'https://www.youtube.com/embed/8QsEyZ9dTwE?rel=0&modestbranding=1',
              },
              {
                Name: 'Energy Transfers and Power',
                ShortName: 'Energy-Transfers-and-Power',
                Link: 'https://www.youtube.com/embed/bAiQYooP6XI?rel=0&modestbranding=1',
              },
              {
                Name: 'Power and Resistance',
                ShortName: 'Power-and-Resistance',
                Link: 'https://www.youtube.com/embed/xe4J0NHlFdE?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P3 — Particle Model of Matter',
            Subcategories: [
              {
                Name: 'Investigating Density',
                ShortName: 'Investigating-Density',
                Link: 'https://www.youtube.com/embed/L9E_e8Q814g?rel=0&modestbranding=1',
              },
              {
                Name: 'Specific Latent Heat',
                ShortName: 'Specific-Latent-Heat',
                Link: 'https://www.youtube.com/embed/lJv-pvoThPk?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P4 — Atomic Structure',
            Subcategories: [
              {
                Name: 'Uses of Nuclear Radiation',
                ShortName: 'Uses-of-Nuclear-Radiation',
                Link: 'https://www.youtube.com/embed/OhIWz7KDkZw?rel=0&modestbranding=1',
              },
              {
                Name: 'Nuclear Equations',
                ShortName: 'Nuclear-Equations',
                Link: 'https://www.youtube.com/embed/1WltKjOBMhM?rel=0&modestbranding=1',
              },
              {
                Name: 'Half-life',
                ShortName: 'Half-life',
                Link: 'https://www.youtube.com/embed/1EwCc2ItMeo?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic P5a — Force Basics and Springs',
            Subcategories: [
              {
                Name: 'Weight',
                ShortName: 'Weight',
                Link: 'https://www.youtube.com/embed/bHxvKmKYjxI?rel=0&modestbranding=1',
              },
              {
                Name: 'Work Done',
                ShortName: 'Work-Done',
                Link: 'https://www.youtube.com/embed/4tkvOfqiB0k?rel=0&modestbranding=1',
              },
              {
                Name: 'Spring Constant',
                ShortName: 'Spring-Constant',
                Link: 'https://www.youtube.com/embed/TdjRewv7nKg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P5b — Forces and Motion',
            Subcategories: [
              {
                Name: 'Speed',
                ShortName: 'Speed',
                Link: 'https://www.youtube.com/embed/w3jlwjfPcPw?rel=0&modestbranding=1',
              },
              {
                Name: 'Acceleration',
                ShortName: 'Acceleration',
                Link: 'https://www.youtube.com/embed/YBx3NEUn3Uc?rel=0&modestbranding=1',
              },
              {
                Name: 'Distance-Time Graphs',
                ShortName: 'Distance-Time-Graphs',
                Link: 'https://www.youtube.com/embed/7rJ6jsDcgCI?rel=0&modestbranding=1',
              },
              {
                Name: 'Velocity-Time Graphs',
                ShortName: 'Velocity-Time-Graphs',
                Link: 'https://www.youtube.com/embed/ueeGyuDbap4?rel=0&modestbranding=1',
              },
              {
                Name: "Newton\'s Third Law",
                ShortName: "Newton\'s Third Law",
                Link: 'https://www.youtube.com/embed/LBi-TZJjPXk?rel=0&modestbranding=1',
              },
              {
                Name: 'Braking Force',
                ShortName: 'Braking-Force',
                Link: 'https://www.youtube.com/embed/7CrEfvJnxBI?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P6 — Waves',
            Subcategories: [
              {
                Name: 'Wave Speed',
                ShortName: 'Wave-Speed',
                Link: 'https://www.youtube.com/embed/HEVIHl13H6s?rel=0&modestbranding=1',
              },
              {
                Name: 'Refraction',
                ShortName: 'Refraction',
                Link: 'https://www.youtube.com/embed/w7kc_EI-5vw?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P7 — Magnetism and Electromagnetism',
            Subcategories: [
              {
                Name: 'Electromagnetism',
                ShortName: 'Electromagnetism',
                Link: 'https://www.youtube.com/embed/xuppYA-hIRA?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.HowToRevise,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#0993A3',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: 'how-to-revise',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'How to Revise',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "We\'ve spilled all the secrets to help you get the most out of your book and CGP RevisionHub",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Revision tips and tricks',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        LeftSections: [],
        RightSections: [],
        Title: '',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      IntroTitle: '',
      AdditionalInfo: '',
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Complete Revision and Practice',
      AdditionalText: "(it's got all the important facts, theory and skills you need to know!)",
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, resource sheets, exam tips and a glossary... yep, it's all right here.",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Formula sheets, a periodic table and more!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Your printable answers, resource sheets, exam tips and more are all below. Take your pick!</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combinedscience-commandwords-foundation-revisionandpractice.pdf" target="_blank">Command Word Glossary</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combinedscience-examrules-foundation-revisionandpractice.pdf" target="_blank">Golden Rules for Your Exam</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combined-biology-diagrams-foundation-revisionandpractice.pdf" target="_blank">Key Biology Diagrams</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combined-chemistry-periodictable-foundation-revisionandpractice.pdf" target="_blank">The Periodic Table</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combined-physics-formulasheet-foundation-revisionandpractice.pdf" target="_blank">Physics Formulas</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combined-biology-summaryanswers-foundation-revisionandpractice.pdf" target="_blank">Biology&nbsp;Revision Summary Test Answers</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combined-chemistry-revisionsummaryanswers-foundation-revisionandpractice.pdf" target="_blank">Chemistry&nbsp;Revision Summary Test Answers</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SCAFS43/PDFs/cgp-gcse-combined-physics-summaryanswers-foundation-revisionandpractice.pdf" target="_blank">Physics&nbsp;Revision Summary Test Answers</a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        'We’ve put together lots of helpful information on how to get the most out of your Complete Revision and Practice. And if you’ve hit any snags, you’ll find the answers you need here too. ',
      Text:
        '   <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science books. Use the quizzes, tests, videos and more to revise what you’ve learned from your book and practise for the exams.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I access CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig so you can practise exactly what you've just learned!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>My RevisionHub isn’t working — what do I do?&nbsp;</h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also lots of useful bits that you can download as PDFs to access offline. Phew.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What’s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the key facts, maths skills and practical skills on the course. There's one on almost every page of your book — we're generous like that.</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier.</p>\n" +
        '\n' +
        "<p>Revision Summary Tests include more challenging questions — if you can do them all, you'll know you've covered everything. You'll find one at the end of every section in your book and you can mark them yourself using our example answers.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in the Hub and start again?&nbsp;</h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Plus, you can edit your Revision Summary Test answers as your skills and understanding develop. Keep going, we believe in you!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I share my quiz scores and test results with other people?&nbsp;</h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I’ve answered all the questions?&nbsp;</h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. Check out the How To Revise page in your RevisionHub if you want more top revision tips before your exams.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise.<br>\n" +
        '&nbsp;</p>',
      VideoLink: 'https://www.youtube.com/embed/P8IHunVEtw0?rel=0&modestbranding=1',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from. Take a look at some of our other books!",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
];
